import styled from 'styled-components'
import { CustomScrollbarMixin } from '../../../../css/CustomScrollbarMixin'
import { useAppSelector } from '../../../../store/hooks'
import { getMenuState } from '../../../../store/menuSlice'
import { SubMenu } from './Submenu'
import { useState } from 'react'

export const MENU_ROOT_ID = '/'

const MenuSectionRoot = styled.section`
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--tds-grey-300);
`

const ConfiguratorMenuRoot = styled.div`
  ${CustomScrollbarMixin}
  width: var(--configurator-menu-width);
  display: flex;
  flex: 1 1 0;
  flex-flow: column;
  overflow-y: auto;
  overflow-x: hidden;
`

const SubMenuWrapper = styled.div``

/**
 * A node in the currently visible menu tree.
 */
export interface VisibleMenuEntry {
  childIds: string[] | null
  hasReadmore: boolean
  id: string
  isOpen: boolean
  parentId: string | null
  text: string
}

/**
 * An item that is selected or can be selected inside one of
 * deepest/outmost/leaf menus.
 */
export interface LeafMenuEntry {
  hasReadmore: boolean
  id: string
  isSelected: boolean
  text: string
}

export interface ConfiguratorMenuProps {
  highlightedId: string | null
}

export function SideMenu({
  highlightedId,
}: ConfiguratorMenuProps): JSX.Element {
  const menuTree = useAppSelector(getMenuState).menuResultAllView?.menuTree
  const menuLevel2 = menuTree?.subMenus
    ? menuTree?.subMenus.find((menu) => menu.isOpen === true)?.subMenus
    : null
  const [closeCabColourMenuFirstTime, setCloseCabColourMenuFirstTime] =
    useState<boolean>(true)

  return (
    <MenuSectionRoot>
      <ConfiguratorMenuRoot data-name="MainMenu">
        <SubMenuWrapper>
          {menuLevel2?.map((menuItem) => {
            return (
              <SubMenu
                key={menuItem.id}
                menuLevel={2}
                node={menuItem}
                highlightedId={highlightedId}
                closeCabColourMenuFirstTime={closeCabColourMenuFirstTime}
                setCloseCabColourMenuFirstTime={() =>
                  setCloseCabColourMenuFirstTime(false)
                }
              />
            )
          })}
        </SubMenuWrapper>
      </ConfiguratorMenuRoot>
    </MenuSectionRoot>
  )
}
